<template>
  <ib-button
    :disabled="!canEdit"
    font-family="regular"
    @click="onClick"
  >
    <i class="icon ib-icon ib-icon-plus-math mr-1" />
    <span class="font-outfit-regular">{{ $t('add') }}</span>
  </ib-button>
</template>

<script>
import EventBus from '@/event-bus'
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'

export default {
  name: 'AddEditButton',

  mixins: [MixinIdeaRoles],

  methods: {
    onClick () {
      EventBus.$emit('add-edit')
    }
  }
}
</script>
